import React from 'react';

// Hemos vaciado este componente para eliminar la función de dictado.
// Al retornar 'null', el botón desaparece visualmente y la lógica de grabación deja de existir.
const DictationButton = () => {
  return null;
};

export default DictationButton;